<template>
  <div>
    <div class="view-header">
      <h1 class="is-size-5 is-expanded">Service Request</h1>
    </div>
    <div class="box">
      <div class="columns">
        <div class="column">
          <input-field
            label="From"
            type="date"
            v-model="from"
            required
          ></input-field>
        </div>
        <div class="column">
          <input-field
            label="To"
            type="date"
            v-model="to"
            required
          ></input-field>
        </div>
        <div class="column">
          <input-field
            label="Employee Id"
            v-model="engineerEmployeeId"
          ></input-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <input-field
            label="Customer Name"
            type="text"
            v-model="customerName"
          ></input-field>
        </div>
        <div class="column">
          <input-field
            label="Serial Number"
            type="text"
            v-model="serialNumber"
          ></input-field>
        </div>
        <div class="column">
          <input-field
            label="Model Number"
            type="text"
            v-model="modelNumber"
          ></input-field>
        </div>
      </div>
      <hr />
      <div class="columns">
        <div class="column">
          <router-link class="button" to="/export">Back</router-link>
        </div>
        <div class="column has-text-right">
          <div class="buttons is-pulled-right">
            <button
              class="button"
              @click="onDownload"
              :class="{ 'is-loading': downloading }"
            >
              Download Zip
            </button>
            <button
              class="button"
              @click="onClick"
              :class="{ 'is-loading': loading }"
            >
              Export CSV
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import http from "../../../http";
import moment from "moment";
export default {
  data() {
    return {
      from: "",
      to: "",
      engineerEmployeeId: "",
      customerName: "",
      serialNumber: "",
      modelNumber: "",
      loading: false,
      downloading: false
    };
  },
  methods: {
    onClick() {
      let component = this;
      component.loading = true;
      http
        .post("/request/service/export/csv", {
          from: component.from,
          to: component.to,
          engineerEmployeeId: component.engineerEmployeeId,
          customerName: component.customerName,
          serialNumber: component.serialNumber,
          modelNumber: component.modelNumber
        })
        .then(response => {
          let element = document.createElement("a");
          element.setAttribute(
            "href",
            `data:text/csv;charset=utf-8,${encodeURI(response.data)}`
          );
          element.setAttribute(
            "download",
            `${moment().format("YYYYMMDDHHmm")} - Service Requests.csv`
          );
          element.click();
          document.body.removeChild(element);
          component.loading = false;
        })
        .catch(error => {
          console.error(error);
          component.loading = false;
        });
    },
    onDownload() {
      let component = this;
      component.downloading = true;
      http
        .post("/request/service/export/zip", {
          from: component.from,
          to: component.to,
          engineerEmployeeId: component.engineerEmployeeId,
          customerName: component.customerName,
          serialNumber: component.serialNumber,
          modelNumber: component.modelNumber
        })
        .then(response => {
          let element = document.createElement("a");
          element.setAttribute(
            "href",
            `data:application/zip;base64,${encodeURI(response.data)}`
          );
          element.setAttribute(
            "download",
            `${moment().format("YYYYMMDDHHmm")} - Service Requests.zip`
          );
          element.click();
          component.downloading = false;
        })
        .catch(error => {
          console.error(error);
          component.downloading = false;
        });
    }
  }
};
</script>
